import { gql } from '@apollo/client';

export const RECORD_SEARCH_TERM = gql`
    mutation RecordSearchTerm($input: RecordSearchTermInput!) {
        recordSearchTerm(input: $input) {
            ... on RecordSearchTermSuccess {
                success
            }
            ... on RecordSearchTermError {
                code
                message
            }
        }
    }
`;
